export default __webpack_public_path__ + "static/media/therapeutic1200.6c7ffcd7.jpg";